/**
 * @file Achat maintenu (HoldUpgradeRoutine de l'original) : repetition acceleree tant que le doigt reste pose sur le bouton.
 */

export interface HoldRepeatOptions {
  startMs: number;
  minMs: number;
  /** Multiplicateur d'intervalle a chaque repetition (< 1 = acceleration). */
  accel: number;
  /** Retourne faux pour arreter la repetition (ex. plus assez d'argent). */
  onFire: () => boolean;
}

/** Branche le comportement sur `el` ; retourne la fonction de nettoyage. */
export const attachHoldRepeat = (el: HTMLElement, o: HoldRepeatOptions): (() => void) => {
  let timer: number | null = null;
  let interval = o.startMs;
  const stop = (): void => {
    if (timer !== null) window.clearTimeout(timer);
    timer = null;
  };
  const tick = (): void => {
    if (!o.onFire()) return stop();
    interval = Math.max(o.minMs, interval * o.accel);
    timer = window.setTimeout(tick, interval);
  };
  const down = (e: PointerEvent): void => {
    e.preventDefault();
    stop();
    interval = o.startMs;
    if (!o.onFire()) return;
    timer = window.setTimeout(tick, interval);
  };
  el.addEventListener('pointerdown', down);
  el.addEventListener('pointerup', stop);
  el.addEventListener('pointerleave', stop);
  el.addEventListener('pointercancel', stop);
  return () => {
    stop();
    el.removeEventListener('pointerdown', down);
    el.removeEventListener('pointerup', stop);
    el.removeEventListener('pointerleave', stop);
    el.removeEventListener('pointercancel', stop);
  };
};
